/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHosportsCollectionSliderViewProps } from './hosports-collection-slider';

export default (props: IHosportsCollectionSliderViewProps) => {
    return (
        <h2>{'HO Sports Collection Browser'}</h2>
    );
};
